import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box } from 'reflexbox';

import { ChevronLeftIcon } from '@treams/treams-icons';
import { Button, Container, Toolbar } from '@treams/treams-ui';

import useTalentReviewPath from '../hooks/useTalentReviewPath';
import TalentReviewTemplateEditor from './TalentReviewTemplateEditor';

export default function TalentReviewTemplatePage(props: { id?: string }) {
	const { t } = useTranslation();
	const path = useTalentReviewPath();
	const groupID = new URLSearchParams(useLocation().search).get('groupID') ?? undefined;

	return (
		<Container px={[3, 4, 5]} wide={1080}>
			<Box py={4}>
				<Toolbar>
					<Button
						icon={<ChevronLeftIcon />}
						link={path({ groupID })}
						title={t('talentReviews.v2.back')}
						type="secondary"
					/>
				</Toolbar>
				<TalentReviewTemplateEditor id={props.id} groupID={groupID} />
			</Box>
		</Container>
	);
}
